import {
  Box,
  Checkbox,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import DeleteIcon from "../components/IconComp/deleteIcon";
import { ColorPallet } from "../utils/colorPallet";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import AllTable from "../components/commontable/table";
import { MedicineToolbar } from "../components/inventory/medicine/medicine-tool-bar";
import {
  deleteMedicine,
  getMedicineData,
} from "../features/medicine/medicineSlice";
import WarningIcon from "../components/IconComp/warningIcon";
import WarningIconYellow from "../components/IconComp/warningIconYellow";
import { EditMedicineToolbar } from "../components/inventory/medicine/medicine-edit-toolbar";
import EditIcondisable from "../components/IconComp/editIconDisable";
import DeleteIcondisable from "../components/IconComp/deleteIconDisable";
import { useLocation } from "react-router-dom";
import LoadingSpinner from "../components/common/Loading";
import BlockModel from "../components/common/BlockModel";
import NoDataMessage from "../components/common/NoDataMessage";
import SearchIcon from "../components/IconComp/searchIcon";
import { MedicalProductsHeader } from "../utils/constants";
import usePermissions from "../hooks/usePermissions";
import { MedicinePaginationDTO, PaginationDTO } from "../dtos/manufacturer";
import ErrorToster from "../components/common/ErrorToster";
import HideIcon from "../components/IconComp/hideIcon";
import { HideMedicineModel } from "../components/inventory/medicine/medicine-hide-model";
import AppSnackbar from "../components/common/AppSnackbar";
import PendingIcon from "../components/IconComp/pendingIcon";
import BlueWarningIcon from "../components/IconComp/BlueWarningIcon";

interface IProps {
  // handleClose: () => void;
  // setOpenSnackbar: () => void;
  // getMedicine: () => void;
  medicine?: any;
}
const Medicines = ({ medicine }: IProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isFromResolve = location?.state && location?.state?.fromResolve;
  const [showOutOfStock, setShowOutOfStock] = useState(false);
  const [showLowInStock, setShowLowInStock] = useState(false);
  const [stockNotEntered, setStockNotEntered] = useState(false);
  const [open, setOpen] = useState(false);
  const [medicineID, setMedicineID] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [openErrorToast, setOpenErrorToast] = useState<any>(false);
  const rowData = useAppSelector((state) => state?.medicine);
  const [openHideModal, setOpenHideModal] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState<any>(null);
  const [selectedMedicine, setSelectedMedicine] = useState<any>(null);
  const [apiError, setApiError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const pharmacyId = localStorage?.getItem("pharmacyId");
  const isPermissions = usePermissions();
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );
  //pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(""); // Debounce
  const [lowInStockCount, setLowInStockCount] = useState<any>();
  const [outOfStockCount, setOutOfStockCount] = useState<any>();
  const [stockNotEnteredCount, setStockNotEnteredCount] = useState<any>();
  const searchInputRef = useRef<HTMLInputElement | null>(null); // Ref for search input
  const [medicineId, setMedicineId] = useState("");

  // Debounce effect for search query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust debounce delay as needed
    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  const getMedicine = useCallback(async () => {
    const dto: any = {
      page: page + 1, // API pages are 1-indexed
      limit: rowsPerPage,
      search: debouncedSearchQuery,
      lowStock: isFromResolve || showLowInStock ? showLowInStock : undefined,
      outOfStock: showOutOfStock ? showOutOfStock : undefined,
      medicineWithoutBatch: stockNotEntered ? stockNotEntered : undefined,
    };

    try {
      setIsLoading(true); // Start loading
      const res = await dispatch(
        getMedicineData({ pharmacy_id: pharmacyId, dto })
      );
      if (res.payload) {
        setTotalCount(res?.payload?.pagination?.totalItems || 0); // Ensure number type
        setOutOfStockCount(res?.payload?.count?.outOfStockCount || 0); // Ensure number type
        setLowInStockCount(res?.payload?.count?.lowStockCount || 0); // Ensure number type
        setStockNotEnteredCount(
          res?.payload?.count?.medicineWithoutBatchCount || 0
        ); // Ensure number type
      }
    } catch (error) {
      console.error("Error fetching manufacturer data:", error);
    } finally {
      setIsLoading(false); // Stop loading
      // Only focus if there's an active search query
      if (debouncedSearchQuery) {
        setTimeout(() => {
          searchInputRef.current?.focus();
        }, 0);
      }
    }
  }, [
    dispatch,
    pharmacyId,
    page,
    rowsPerPage,
    debouncedSearchQuery,
    showOutOfStock,
    showLowInStock,
    stockNotEntered,
  ]); // Add dependencies as needed

  useEffect(() => {
    if (Account_Type === 0 || (isPermissions?.view && Account_Type === 1)) {
      getMedicine();
    } else {
      setIsLoading(false);
    }
  }, [getMedicine, isPermissions?.view, Account_Type]);

  const handleOpenHideModal = (medicine: any) => {
    setSelectedMedicine(medicine);
    setOpenHideModal(true);
  };

  const handleCloseModal = () => {
    setApiError(false);
    setOpenModal(false);
  };

  const handleOpen = (id: any) => {
    setMedicineID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setMedicineID(0);
    setOpen(false);
  };
  const handleBlock = () => {
    handleDelete(medicineID);
    handleClose();
  };
  // Preserve cursor position while typing
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { selectionStart, selectionEnd } = e.target; // Save cursor position
    setSearchQuery(e.target.value);
    setPage(0);
    // Restore cursor position after state update
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.setSelectionRange(selectionStart, selectionEnd);
      }
    }, 0);
  };

  const handleDelete = (medicine_id: any) => {
    const obj = {
      pharmacy_id: pharmacyId,
      medicine_id: medicine_id,
    };
    dispatch(deleteMedicine(obj))?.then((res: any) => {
      if (res?.payload?.success === true) {
        getMedicine();
        alert("Deleted successfully");
      } else {
        setError(res?.payload);
        setOpenErrorToast(true);
      }
    });
  };

  // Filter and search data
  const filteredRow = rowData?.medicineDetails?.map((item: any) => ({
    Name: item?.medicine_name,
    Formula: item?.drug_formula_name,
    Dose: ((d?: string) => {
      const cleaned = (d ?? "").replace(/\bnull\b/gi, "").trim();
      return cleaned || "-";
    })(item?.dose),
    "Total Quantity": (() => {
      const totalQuantity = item?.total_quantity;

      return (
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
          {/* <Box>
            {item?.total_quantity === 0 ? (
              <BlueWarningIcon />
            ) : null}
          </Box> */}
          <Box>{totalQuantity?.toLocaleString("en-IN")}</Box>
        </Box>
      );
    })(),
    "Remaining Quantity": (
      <>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
          <Box>
            {item?.shortage === "Yes" ? (
              <WarningIconYellow />
            ) : item?.shortage === "Stock Yet Not Entered" ? (
              <PendingIcon />
            ) : item?.shortage === "Out of Stock" ? (
              <WarningIcon />
            ) : null}
          </Box>
          <Box>
            {(item?.total_quantity - item?.quantity_sold)?.toLocaleString(
              "en-IN"
            )}
          </Box>
        </Box>
      </>
    ),
    "Generic Name": item?.generic_name ? item?.generic_name : "-",
    Category: item?.category_name,
    "Manufacturer Name": item?.manufacturer_name,
    Actions: (
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            cursor: "pointer",
            alignItems: "center",
            padding: "5px 0px",
          }}
        >
          {(Account_Type === 0 ||
            (isPermissions?.delete && Account_Type === 1)) &&
            (item?.is_pharmacy_specific ? (
              <Tooltip title="Delete">
                <Box component="span">
                  <DeleteIcon onClick={() => handleDelete(item?.medicine_id)} />
                </Box>
              </Tooltip>
            ) : (
              <DeleteIcondisable />
            ))}

          {(Account_Type === 0 ||
            (isPermissions?.edit && Account_Type === 1)) &&
            (item?.is_pharmacy_specific ? (
              <EditMedicineToolbar medicine={item} getMedicine={getMedicine} />
            ) : (
              <EditIcondisable />
            ))}

          {item?.shortage === "Out of Stock" && (
            <Tooltip title="Hide this medicine">
              <Box
                onClick={() => handleOpenHideModal(item)}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <HideIcon />
              </Box>
            </Tooltip>
          )}
        </Box>
      </>
    ),
  }));

  const hasAccess =
    Account_Type === 0 || (isPermissions?.view && Account_Type === 1);

  const filteredRowData = hasAccess ? filteredRow : [];

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset to first page when changing page size
  };

  return (
    <>
      <BlockModel
        open={open}
        onClose={handleClose}
        heading="Delete Medicine?"
        blockText="Delete"
        subheading="Are you sure you want to Delete this Medicine?"
        onBlock={handleBlock}
      />

      <>
        {/* <Box sx={{ p: 3, fontSize: "24px", fontWeight: "bold" }}>
          List of Medical Products
        </Box> */}

        <Box
          sx={{
            margin: 1,
            backgroundColor: ColorPallet?.bgcolor,
            // marginTop: "10px",
            // padding: "10px",
            borderRadius: "5px",
            "@media screen and (max-width: 1024px)": {
              padding: "7px",
              margin: 2,
            },
            "@media screen and (max-width: 768px)": {
              padding: "5px",
              margin: 1,
            },
            "@media screen and (max-width: 480px)": {
              padding: "3px",
              margin: 1,
            },
            minHeight: {
              xs: "auto",
              sm: "80vh",
            },
            my: "1.2%",
          }}
        >
          <Box sx={{ px: 1, display: "flex", mt: 1 }}>
            <TextField
              inputRef={searchInputRef} // Assign ref to maintain focus
              placeholder="Search..."
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ width: "350px" }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                fontSize: "14px",
                fontWeight: 400,
                flexDirection: "column",
                "@media screen and (max-width: 480px)": { fontSize: "12px" },
              }}
            >
              {outOfStockCount > 0 && (
                <Box
                  sx={{
                    py: "2px",
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    mt: "5px",
                  }}
                >
                  {!isFromResolve && (
                    <Box sx={{ paddingTop: "2px", paddingLeft: "10px" }}>
                      <WarningIcon />
                    </Box>
                  )}
                  {!isFromResolve && (
                    <Box>
                      Some medicines are{" "}
                      <span style={{ color: "red" }}>out of stock.</span>
                    </Box>
                  )}
                </Box>
              )}
              {lowInStockCount > 0 && (
                <Box
                  sx={{
                    py: "2px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    gap: 1,
                  }}
                >
                  {!isFromResolve && (
                    <Box sx={{ paddingTop: "2px", paddingLeft: "10px" }}>
                      <WarningIconYellow />
                    </Box>
                  )}
                  {!isFromResolve && (
                    <Box>
                      Some medicines are{" "}
                      <span style={{ color: "#B8860B" }}>low in stock.</span>
                    </Box>
                  )}
                </Box>
              )}

              {stockNotEnteredCount > 0 && (
                <Box
                  sx={{
                    py: "2px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    gap: 1,
                  }}
                >
                  {!isFromResolve && (
                    <Box sx={{ paddingTop: "2px", paddingLeft: "10px" }}>
                      <PendingIcon />
                    </Box>
                  )}
                  {!isFromResolve && (
                    <Box>
                      Some medicines have been added but are{" "}
                      <span style={{ color: "#1976d2" }}>awaiting stock </span>
                      entry.
                    </Box>
                  )}
                </Box>
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: { xs: 0, sm: 2 },
                "@media screen and (max-width: 768px)": {
                  flexDirection: "column",
                },
              }}
            >
              {!isFromResolve && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    size="small"
                    checked={stockNotEntered}
                    onChange={(e) => {
                      setStockNotEntered(e?.target?.checked);
                      setPage(0);
                    }}
                  />
                  <Box>
                    Products Without Stock (
                    {stockNotEnteredCount && filteredRowData.length
                      ? stockNotEnteredCount
                      : 0}
                    )
                  </Box>
                </Box>
              )}
              {!isFromResolve && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    size="small"
                    checked={showOutOfStock}
                    onChange={(e) => {
                      setShowOutOfStock(e?.target?.checked);
                      setPage(0);
                    }}
                  />
                  <Box>
                    Out of Stock (
                    {outOfStockCount && filteredRowData.length
                      ? outOfStockCount
                      : 0}
                    )
                  </Box>
                </Box>
              )}
              {!isFromResolve && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    size="small"
                    checked={showLowInStock}
                    onChange={(e) => {
                      setShowLowInStock(e?.target?.checked);
                      setPage(0);
                    }}
                  />
                  <Box>
                    Low in Stock (
                    {lowInStockCount && filteredRowData.length
                      ? lowInStockCount
                      : 0}
                    )
                  </Box>
                </Box>
              )}
              <Box
                sx={{
                  mt: -1,
                  p: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <MedicineToolbar
                  getMedicine={getMedicine}
                  setMedicineId={setMedicineId}
                />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              px: 1,
              paddingBottom: 1,
              width: "100%",
            }}
          >
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "75vh",
                }}
              >
                <LoadingSpinner />
              </Box>
            ) : (
              <AllTable
                headerData={MedicalProductsHeader}
                rowData={filteredRowData}
                page={page}
                rowsPerPage={rowsPerPage}
                totalCount={totalCount}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                hasAccess={hasAccess}
              />
            )}
          </Box>
        </Box>
      </>
      <ErrorToster
        message={error}
        open={openErrorToast}
        handleClose={() => setOpenErrorToast(false)}
      />
      <HideMedicineModel
        open={openHideModal}
        onClose={() => setOpenHideModal(false)}
        selectedMedicineId={selectedMedicine}
        setOpenSnackbar={setOpenSnackbar}
        apiError={apiError}
        setApiError={setApiError}
        setTotalCount={setTotalCount}
        setOutOfStockCount={setOutOfStockCount}
        setLowInStockCount={setLowInStockCount}
        page={page}
        rowsPerPage={rowsPerPage}
      />
      <AppSnackbar
        message="Medicine hidden successfully!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};
export default Medicines;
